import { Subproduct } from "./subProduct";

export class Product {
    key: string;
    planCode?: string;
    productLine: string;
    productName: string;
    subProducts?: Subproduct[];
    productSchedule: string;
}